import { createLazyComponent, LazyModule } from 'owa-bundling';
import { LazyImport } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "MailListItemContextMenu", webpackPrefetch: true */ './lazyIndex');
});
// Delay loaded components
export var MailListItemContextMenu = createLazyComponent(lazyModule, function (m) { return m.MailListItemContextMenu; });
export var ScheduleDatePicker = createLazyComponent(lazyModule, function (m) { return m.ScheduleDatePicker; });
export var lazyCreateScheduleSubMenu = new LazyImport(lazyModule, function (m) { return m.createScheduleSubMenu; });
//# sourceMappingURL=index.js.map